//PYMES Constants
import React from "react";
import imgPYMES from "../assets/pymes-bread.svg";

const titulo = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className='text-info'>Hogar</span>
  </React.Fragment>
);

export const generarPasos = (valorMaximo) => {
  return {
    breadCrumb: {
      title: "Cotización Seguro de Pymes",
      subtitle: "Cotización Seguro de Pymes",
    },

    breadCrumbPasos: {
      1: {
        title: titulo,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Datos Personales",
            active: true,
          },
          {
            title: "2. Coberturas",
          },
          {
            title: "3. Opciones de Pago",
          },
          {
            title: "4. Cotización",
          },
        ],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      2: {
        title: titulo,
        subtitle:
          "Sigamos avanzando en tu cotización, compártenos las características de tu negocio",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Datos Personales asegurado",
            active: true,
          },
          {
            title: "2. Coberturas",
            active: true,
          },
          {
            title: "3. Opciones de Pago",
          },
          {
            title: "4. Cotización",
          },
        ],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      3: {
        title: titulo,
        subtitle:
          "En este portal podrás cotizar y emitir negocios con valores de hasta 10 millones de dólares por ubicación dependiendo el giro.",
        pasosActivos: [1, 2, 3],
        pasos: [
          {
            title: "1. Datos Personales asegurado",
            active: true,
          },
          {
            title: "2. Coberturas",
            active: true,
          },
          {
            title: "3. Opciones de Pago",
            active: true,
          },
          {
            title: "4. Cotización",
          },
        ],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      5: {
        title: titulo,
        subtitle: "Estás a un paso de que tu negocio quede protegido",
        pasosActivos: [1, 2, 3, 4, 5],
        pasos: [
          {
            title: "1. Datos Personales asegurado",
            active: true,
          },
          {
            title: "2. Coberturas",
            active: true,
          },
          {
            title: "3. Opciones de Pago",
            active: true,
          },
          {
            title: "4. Cotización",
            active: true,
          },
        ],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
    },
  };
};

const pasosBreadCrumbHogar = {
  breadCrumb: {
    title: "Cotización Seguro de Hogar",
    subtitle: "Cotización Seguro de Hogar",
  },

  breadCrumbPasos: {
    1: {
      title: titulo,
      subtitle:
        "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
      pasosActivos: [1],
      pasos: [
        {
          title: "1. Datos personales",
          active: true,
        },
        {
          title: "2. Elige el plan",
        },
        {
          title: "3. Opción de pago",
        },
        {
          title: "4. Confirma tu compra",
        },
      ],
      img: imgPYMES,
      styleimg: "img-fluid img-breadcrumb",
    },
    2: {
      title: titulo,
      subtitle:
        "Sigamos avanzando en tu cotización, compártenos las características de tu negocio",
      pasosActivos: [1, 2],
      pasos: [
        {
          title: "1. Datos Personales asegurado",
          active: true,
        },
        {
          title: "2. Coberturas",
          active: true,
        },
        {
          title: "3. Opciones de Pago",
        },
        {
          title: "4. Cotización",
        },
      ],
      img: imgPYMES,
      styleimg: "img-fluid img-breadcrumb",
    },
    3: {
      title: titulo,
      subtitle: "Estás muy cerca de obtener tu seguro para hogar.",
      pasosActivos: [1, 2, 3],
      pasos: [
        {
          title: "1. Datos Personales asegurado",
          active: true,
        },
        {
          title: "2. Coberturas",
          active: true,
        },
        {
          title: "3. Opciones de Pago",
          active: true,
        },
        {
          title: "4. Cotización",
        },
      ],
      img: imgPYMES,
      styleimg: "img-fluid img-breadcrumb",
    },
    4: {
      title: titulo,
      subtitle:
        "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
      pasosActivos: [1, 2, 3, 4],
      pasos: [
        {
          title: "1. Datos Personales asegurado",
          active: true,
        },
        {
          title: "2. Coberturas",
          active: true,
        },
        {
          title: "3. Opciones de Pago",
          active: true,
        },
        {
          title: "4. Opción de pago",
          active: true,
        },
        {
          title: "5. Confirma tu compra",
        },
      ],
      img: imgPYMES,
      styleimg: "img-fluid img-breadcrumb",
    },
    5: {
      title: titulo,
      subtitle: "Estás a un paso de que tu negocio quede protegido",
      pasosActivos: [1, 2, 3, 4, 5],
      pasos: [
        {
          title: "1. Datos Personales asegurado",
          active: true,
        },
        {
          title: "2. Coberturas",
          active: true,
        },
        {
          title: "3. Opciones de Pago",
          active: true,
        },
        {
          title: "4. Cotización",
          active: true,
        },
      ],
      img: imgPYMES,
      styleimg: "img-fluid img-breadcrumb",
    },
  },
};

export default pasosBreadCrumbHogar;
